export const titles = ['MR', 'MRS', 'MS', 'MISS', 'MSTR', 'DR'];
export const airClasses = ['Economy', 'Business', 'FirstClass', 'PremiumEconomy'];
export const ages = ['adult', 'infant', 'child' ]
export const transferPointType = ['home', 'unknown', 'airport', 'hotel' ]
export const mealTypes = ['unknown', 'BB', 'HB', 'HBplus', 'FB', 'FBplus', 'AL', 'ALplus', 'UAI', 'OB'   ]
export const documentTypes = ['none', 'vaucher', 'ticket', 'brochure'];
export const tripItemTypes = ['etc', 'hotel', 'ticket', 'transfer']
